import React, { useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { column } from './commonCSS';
import TextField2FA from './TextField2FA';
import EmailCodeStep from './EmailCodeStep';
import { useMutationFetch } from './useQueryFetch';
import { useQueryClient } from '@cd/react-query';
import { useStore } from './store';
//import {  } from '@mui/icons-material';

// method: 'email' mails a code to confirm; 'app' asks for the app's code.
const Disable2FADlg = ({ method }) =>
	method === 'email' ? (
		<Paper css={column} sx={{ alignItems: 'center', p: 4 }}>
			<EmailCodeStep
				purpose="disable"
				finishUrl="/account/2fa/setup/disable"
				successMessage="2FA has been canceled!"
				intro="Are you sure you want to disable 2FA?"
			/>
		</Paper>
	) : (
		<DisableAppDlg />
	);

const DisableAppDlg = () => {
	const [value, setValue] = React.useState('');
	const [showIsInvalid, setShowIsInvalid] = React.useState(false);
	const queryClient = useQueryClient();
	const { dispatch } = useStore();
	const { mutate, data } = useMutationFetch('/account/2fa/setup/disable', {
		onSuccess: () => {
			queryClient.refetchQueries('fetch2fasettings');
		}
	});

	useEffect(() => {
		if (data?.isValid === false) {
			setShowIsInvalid(true);
		} else if (data?.isValid === true) {
			dispatch({ type: 'close dialog' });
			dispatch({
				type: 'post success',
				message: '2FA has been canceled!'
			});
		}
	}, [data]);

	return (
		<Paper css={column} sx={{ alignItems: 'center', p: 4 }}>
			<Typography variant="body2" sx={{ pb: 1 }}>
				Are you sure you want to disable 2FA?
			</Typography>
			<Typography variant="body2" sx={{ pb: 1 }}>
				Please enter your 6 digit verification code from the app.
			</Typography>
			<TextField2FA
				sx={{
					mt: 2,
					position: 'relative'
				}}
				value={value}
				setValue={setValue}
				showIsInvalid={showIsInvalid}
				setShowIsInvalid={setShowIsInvalid}
				onClick={e => {
					mutate({
						token: value
					});
				}}
			/>
		</Paper>
	);
};
export default Disable2FADlg;
